import { CartItem, OrderDetail } from '../../../../../core';
const iconsOfActionsList2 = [
  {
    icon: 'edit',
    hasVisibleCondition: (element: OrderDetail[]): boolean => true
  },
  {
    icon: 'delete_outline',
    hasVisibleCondition: (element: OrderDetail[]): boolean => true
  }
];
export const isSaleCustomer = {


  expandable: false,
  expandableType: 'ProductCard',
  checkbox: false,
  detailQuantity: false,
  iconFooter: iconsOfActionsList2,
  items: [
    {
      title: 'Sku',
      name: 'skuCode',
      class: 'col-6',
      value: (element: CartItem) => element.skuCode
    },
    {
      title: 'Producto',
      name: 'description',
      class: 'col-12',
      value: (element: CartItem) => element.description
    },
    {
      title: 'Modalidad de entrega',
      name: 'deliveryMode',
      class: 'col-6',
      value: (element: CartItem) => element.deliveryMode === 'HOME_DELIVERY' ? 'DESPACHO A DOMICILIO' : 'RETIRO EN TIENDA'
    },
    {
      title: 'Cant.',
      name: 'quantity',
      class: 'col-6',
      value: (element: CartItem) => element.quantity
    },
    {
      title: 'Origen',
      name: 'description',
      class: 'col-6',
      value: (element: CartItem) => element.originDescription
    },
    {
      title: 'Destino',
      name: 'quantity',
      class: 'col-6',
      value: (element: CartItem) => element.deliveryMode === 'STORE_WITHDRAWAL' ? element.destinationDescription : element.deliveryAddress ? element.deliveryAddress.address + ' Nro. ' + element.deliveryAddress.number : '----'
    },
    {
      title: 'Fecha de entrega',
      name: 'quantity',
      onFooter: true,
      value: (element: CartItem) => element.deliveryDate
    }
  ]
};
